import { ComponentStyleConfig } from '@chakra-ui/theme'

export const Modal: ComponentStyleConfig = {
  parts: ['dialog', 'dialogContainer', 'header', 'footer', 'closeButton'],
  baseStyle: {
    dialog: {
      width: '90% !important',
    },
    header: {
      // borderBottom: '1px solid',
      borderColor: 'gray.100',
      fontSize: 'lg',
    },
    body: {
      padding: '24px',
    },
    footer: {
      borderTop: '1px solid',
      borderColor: 'gray.100',
    },
  },
}
